import React, { Component, createRef } from "react";
import "../carousel/Carousel.css";

export default class Carousel extends Component {
  state = {
    currentId: this.props.index,
    centerPos: 0,
  };

  mainRef = createRef();

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.slideTo(this.props.index);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    // Re-center based on actual DOM (no incremental drift)
    this.slideTo(this.state.currentId);
  };

  slideTo = (id) => {
    if (id > this.props.maximumStep && this.props.stepper) {
      id = this.props.maximumStep;
    }

    this.setState({ currentId: id }, () => {
      this.recenterUntilStable(id, 6); // try up to 6 frames
    });
  };

  recenterUntilStable = (id, triesLeft) => {
    requestAnimationFrame(() => {
      const sliderEl = this.mainRef.current;
      if (!sliderEl) return;

      const carouselEl = sliderEl.children[1];
      const itemEl = carouselEl?.children?.[id];
      if (!carouselEl || !itemEl) return;

      // Compute absolute centerPos (stable, no incremental drift)
      const itemCenterInTrack = itemEl.offsetLeft + itemEl.offsetWidth / 2;
      const sliderCenter = sliderEl.clientWidth / 2;
      const nextCenterPos = sliderCenter - itemCenterInTrack;

      // Apply it
      this.setState({ centerPos: nextCenterPos }, () => {
        if (triesLeft <= 1) {
          this.props.callback(id);
          return;
        }

        // Check if item width has stabilized after the transform + font/layout
        const widthNow = itemEl.offsetWidth;

        requestAnimationFrame(() => {
          const widthAfter = itemEl.offsetWidth;

          // If width changed, layout is still settling (font swap / transition). Try again.
          if (widthAfter !== widthNow) {
            this.recenterUntilStable(id, triesLeft - 1);
          } else {
            // Also verify we're actually centered (in case offsetLeft shifts due to layout)
            this.props.callback(id);
          }
        });
      });
    });
  };

  handleWheelEvent = (e) => {
    e.persist();
    const { currentId } = this.state;
    const nextIndex = e.deltaY > 0 ? currentId + 1 : currentId - 1;

    if (nextIndex >= 0 && nextIndex < this.props.array.length) {
      this.slideTo(nextIndex);
    }
  };

  render() {
    const { currentId, centerPos } = this.state;
    const { array, title } = this.props;

    const styleSelectedItem = (id) =>
        currentId === id ? "carousel-selected" : "carousel-item";

    return (
        <div ref={this.mainRef} className="slider">
          <div className="carousel-header">{title}</div>

          <div
              className="carousel"
              style={{ transform: `translateX(${centerPos}px)` }}
              onWheel={this.handleWheelEvent}
          >
            {array.map((item, id) => (
                <div
                    key={item}
                    className={styleSelectedItem(id)}
                    onClick={() => this.slideTo(id)}
                >
                  {item}
                </div>
            ))}
          </div>
        </div>
    );
  }
}
